// extracted by mini-css-extract-plugin
module.exports = {"unitPrice":"unitPrice_unitPrice__7zi5n"};